const PHONE_REGEX = RegExp('^(?=.*[0-9])[ -+()0-9]+$');
const MIN_PHONE_LENGTH = 9;

export const isValidPhone = (phone?: string) => {
  if (!phone) {
    return false;
  }

  const isFormatValid = PHONE_REGEX.test(phone);

  if (!isFormatValid) {
    return false;
  }

  return phone.replace(/[^0-9.]+/g, '').length >= MIN_PHONE_LENGTH;
};
